import AppFormInput from '../../../components/ui/AppFormInput';
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import apiClient from "../../../services/api-client";
import logo from "../../../assets/images/logo.png";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Toast } from "primereact/toast";

const Reset = () => {
  const [inputValue, setInputValue] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [resetStep, setResetStep] = useState(1);
  const [userId, setUserId] = useState("");
  const otpOptions = ["EMAIL", "PHONE"];
  const [otpOption, setOtpOption] = useState(otpOptions[0]);
  const toast = useRef(null);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (resetStep === 1) {
      if (!validateInput()) {
        return;
      }
      setError("");

      try {
        const response = await apiClient.post("user/requestPasswordResetLink", {
          accessToken: "",
          operation: "request-password-reset-link",
          requestBody: {
            username: inputValue,
          },
        });

        if (response.data.status === "SUCCESS") {
          showToast(
            "info",
            "OTP Sent",
            "Check your " + otpOption.toLowerCase() + ", we sent you an OTP",
            5000
          );

          setUserId(response.data.responseBody?.userId);
          setResetStep(2);
        } else {
          showToast("warn", "Error", response.data.message, 4000);
        }
      } catch (error) {
        setError("Failed to request password reset link. Please try again later.");
      }
    } else {
      if (!validatePassword()) {
        setError("Please enter a valid password and confirm password.");
        return;
      }
      setError("");

      try {
        const response = await apiClient.post(`user/resetNewPassword/${userId}/${otpValue}`, {
          accessToken: "",
          operation: "set-new-password",
          requestBody: {
            username: inputValue,
            password: password,
          },
        });

        if (response.data.status === "SUCCESS") {
          showToast("success", "Success", "Password reset successful", 3000);
          window.location.href = "/signin";
        } else {
          showToast("warn", "Error", response.data.message, 4000);
        }
      } catch (error) {
        showToast("error", "Error", "Error occured, advise the customer service", 5000);
      }
    }
  };

  const showToast = (severity, summary, message, period) => {
    toast.current.show({
      severity: severity,
      summary: summary,
      detail: message,
      life: period,
    });
  };

  const handleResendOTP = async () => {
    try {
      const response = await apiClient.post("user/requestPasswordResetLink", {
        accessToken: "",
        operation: "resend-otp",
        requestBody: {
          username: inputValue,
        },
      });

      if (response.data.status === "SUCCESS") {
        showToast(
          "info",
          "OTP Sent",
          "Check your " + otpOption.toLowerCase() + ", we sent you an OTP",
          5000
        );
        setUserId(response.data.responseBody?.userId);
        setResetStep(2);
      } else {
        showToast("warn", "Error", response.data.message, 4000);
      }
    } catch (error) {
      showToast("error", "Error", "Failed to resend OTP. Please try again later.", 5000);
    }
  };

  const validateInput = () => {
    if (otpOption === "EMAIL") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isEmailValid = inputValue.match(emailRegex);
      !isEmailValid ? setError("Please enter a valid email address.") : setError("");
      return isEmailValid;
    } else {
      const phoneRegex = /^\d{6,}$/;
      const isPhoneValid = phoneRegex.test(inputValue);
      !isPhoneValid ? setError("Please enter a valid phone number.") : setError("");
      return isPhoneValid;
    }
  };

  const validatePassword = () => {
    return password !== "" && password === confirmPassword;
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="min-h-screen bg-[#F8FAFC] flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <div className="text-center mb-8 flex flex-col items-center">
            <Link to={"/landing"} className="flex items-center justify-center space-x-3 mb-6">
              <img className="h-10 w-auto" src={logo} alt="Doves Life Assurance" />
              <span className="bg-[#EBF5FF] text-[#135A9C] font-black text-[10px] px-3 py-1 rounded-full uppercase tracking-widest">
                Self-Service Portal
              </span>
            </Link>
            <h1 className="text-2xl font-extrabold text-slate-800 mt-2 tracking-tight">
              {resetStep === 1 ? "Forgot your password?" : "Check your " + otpOption.toLowerCase()}
            </h1>
            <p className="mt-2 text-sm text-slate-500">
              {resetStep === 1
                ? "Choose how you'd like to receive your reset code."
                : "Enter the OTP we sent you and choose a new password."}
            </p>
          </div>

          <div className="bg-white py-8 px-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:rounded-3xl sm:px-10 border border-slate-100">
            <form onSubmit={handleFormSubmit} className="space-y-4">
              {resetStep === 1 ? (
                <>
                  <div className="form-control w-full mb-2">
                    <label className="label py-1">
                      <span className="label-text text-xs font-bold text-slate-700">Send my code via</span>
                    </label>
                    <div className="join w-full">
                      {otpOptions.map((option) => (
                        <button
                          key={option}
                          type="button"
                          onClick={() => setOtpOption(option)}
                          className={`join-item btn flex-1 font-bold border-slate-300 ${
                            otpOption === option
                              ? "bg-[#135A9C] hover:bg-[#0f4b82] text-white border-[#135A9C]"
                              : "btn-ghost bg-white text-slate-600"
                          }`}
                        >
                          {option === "EMAIL" ? "Email" : "Phone"}
                        </button>
                      ))}
                    </div>
                  </div>

                  {otpOption === "EMAIL" ? (
                    <AppFormInput
                      type="text"
                      placeholder="Enter your email address here"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      error={error}
                      required
                    />
                  ) : (
                    <div className="form-control w-full space-y-1 mb-4">
                      <PhoneInput
                        country={"zw"}
                        international={false}
                        value={inputValue}
                        onChange={(value) => setInputValue(value)}
                        placeholder="263 717 787 787"
                      />
                      {error && <p className="text-error text-xs mt-1">{error}</p>}
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn w-full rounded-full font-bold mt-2 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none"
                  >
                    Submit
                  </button>
                </>
              ) : (
                <>
                  <AppFormInput
                    label="Enter the OTP"
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    inputClassName="text-center tracking-[0.5em] font-mono font-bold"
                    value={otpValue}
                    onChange={(e) => setOtpValue(e.target.value)}
                    error={error}
                    required
                  />

                  <AppFormInput
                    label="Password"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    hint="At least 8 characters, with an uppercase letter, a number and a special character."
                  />

                  <AppFormInput
                    label="Confirm password"
                    type="password"
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={error}
                    required
                  />

                  <button
                    type="submit"
                    className="btn w-full rounded-full font-bold mt-2 bg-[#135A9C] hover:bg-[#0f4b82] text-white border-none"
                  >
                    Submit
                  </button>

                  <p className="pt-4 border-t border-slate-100 text-center text-xs text-slate-500">
                    Don&apos;t have a code?{" "}
                    <button
                      type="button"
                      className="font-bold text-[#135A9C] hover:underline"
                      onClick={handleResendOTP}
                    >
                      Resend
                    </button>
                  </p>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reset;
